module.exports = __webpack_public_path__ + "static/media/get-app.68db0a54.svg";